const items = document.querySelectorAll('.js-feed-item');
const buttonClass = '.js-feed-item-button';
const buttonTextClass = '.js-feed-item-text';

if (items.length > 0) {
    items.forEach((item) => {
        const bclss = item.querySelector(buttonClass)
        if (bclss) {
            bclss.addEventListener('click', () => {
                // closeAllButtons()
                item.classList.toggle('active');
                toggleButtonText(item)
            })
        }
    })
}
// смена надписей на кнопке разворота/сворачивания новости
function toggleButtonText (thisItem) {
    if(thisItem.classList.contains('active')) {
        thisItem.querySelector(buttonTextClass).innerText = 'Свернуть';
    }
    else {
        thisItem.querySelector(buttonTextClass).innerText = 'Подробнее';
    }
}

// закрываем все открыте новости
function closeAllButtons () {
    items.forEach((item) => {
        item.classList.remove('active');
        item.querySelector(buttonTextClass).innerText = 'Подробнее';
    });
}
